import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n, { initLocale } from './i18n'

Vue.config.productionTip = false

// 初始化语言设置
initLocale()

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
